import React, { SVGAttributes } from 'react';

type GraphicComponentProps = SVGAttributes<SVGGraphicsElement>;

// Base circle graphic for small circled icons. This circle is centered in a "0 0 14 14" coordinate
// space. The radius accounts for a variety of stroke widths up to 1.2. If needing a higher weight,
// either parameterize the radius or create a new circle for use.
export const IconCircle = ({ strokeWidth = 1 }: GraphicComponentProps) => (
  <circle fill="none" strokeWidth={strokeWidth} cx="7" cy="7" r="6.4" />
);

// Based on "0 0 8 14" coordinate space.
export const Chevron = ({ stroke, strokeWidth }: GraphicComponentProps) => (
  <path
    stroke={stroke}
    strokeWidth={strokeWidth}
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M1.4 1.4L7 7L1.4 12.6"
  />
);

// Unclosed circle based on a "0 0 14 14" coordinate space
export const PartialCircle = ({ stroke, strokeWidth = 1, ...props }: GraphicComponentProps) => (
  <path
    stroke={stroke}
    strokeWidth={strokeWidth}
    {...props}
    strokeLinecap="round"
    fill="none"
    d="M8.15 0.7a6.4 6.4 0 1 0 5.2 5.5"
  />
);

export const Thumb = ({ stroke, strokeWidth = 1.33, ...props }: GraphicComponentProps) => (
  <path
    fill="none"
    stroke={stroke}
    strokeWidth={strokeWidth}
    {...props}
    strokeLinejoin="round"
    d="M5.33 13.33h-2C2.6 13.33 2 12.73 2 12V8.67c0-.74.6-1.34 1.33-1.34h2M5.3,13.33L5.33,7.33L7.46,2.43C7.58,2.16,7.86,1.99,8.15,2.03C9.56,2.19,10.07,3.07,9.67,4.67L9.44,5.59A0.33,0.33,0,0,0,9.76,6H12.4A1.33,1.33,0,0,1,13.71,7.57L12.87,12.24C12.75,12.87,12.2,13.34,11.55,13.34H5.31Z"
  />
);
